import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { receiveRoute } from '@m/cabinet/components/views/utils'
import Receive from '@m/cabinet/components/views/Receive.vue'

import {
  GENERAL_TAB_KEY,
  DOCUMENTS_TAB_KEY,
  SPECIALIZATION_TAB_KEY,
  PLACE_OF_EMPLOYMENT_TAB_KEY,
} from '@/modules/cabinet/modules/Doctor/const'
import { adminApi } from '@/services/admin.service'

export const STAFF_DOCTORS_MODEL_PATH = 'doctors/'

export const STAFF_DOCTORS_VIEW_NAME = 'staff:doctors'

const prefix = (name: string) => STAFF_DOCTORS_VIEW_NAME + ':' + name
const s = (name: string) => name + '/'

export const STAFF_DOCTORS_LIST_VIEW_NAME = prefix('list')

export const STAFF_DOCTOR_VIEW_NAME = prefix('view')
export const STAFF_DOCTOR_GENERAL_VIEW_NAME = prefix(GENERAL_TAB_KEY)
export const STAFF_DOCTOR_DOCUMENTS_VIEW_NAME = prefix(DOCUMENTS_TAB_KEY)
export const STAFF_DOCTOR_SPECIALIZATION_VIEW_NAME = prefix(
  SPECIALIZATION_TAB_KEY
)
export const STAFF_DOCTOR_PLACE_OF_EMPLOYMENT_VIEW_NAME = prefix(
  PLACE_OF_EMPLOYMENT_TAB_KEY
)

const StaffDoctorsListView = () => import('./views/StaffDoctorsList.vue')

const View = () => import('./views/View.vue')

const General = () =>
  import('@m/cabinet/modules/Staff/modules/Doctors/tabs/General.vue')
const Documents = () =>
  import('@m/cabinet/modules/Staff/modules/Doctors/tabs/Documents.vue')
const Specializations = () =>
  import('@m/cabinet/modules/Staff/modules/Doctors/tabs/Specializations.vue')
const PlaceOfEmployment = () =>
  import('@m/cabinet/modules/Staff/modules/Doctors/tabs/PlaceOfEmployment.vue')

export function createStaffDoctorsRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    { path: '', redirect: { name: STAFF_DOCTORS_LIST_VIEW_NAME } },
    route('list/', StaffDoctorsListView, STAFF_DOCTORS_LIST_VIEW_NAME, {
      meta: {
        title: $t('All doctors'),
      },
    }),

    prefixRoutes(
      '',
      [
        {
          name: STAFF_DOCTOR_VIEW_NAME,
          redirect: { name: STAFF_DOCTOR_GENERAL_VIEW_NAME },
          ...(receiveRoute(
            adminApi.doctors.detail,
            [
              prefixRoutes(
                '',
                [
                  route(
                    s(GENERAL_TAB_KEY),
                    General,
                    STAFF_DOCTOR_GENERAL_VIEW_NAME,
                    {
                      meta: {
                        isHideCabinetHead: true,
                        title: () => $t('Doctor general information'),
                      },
                    }
                  ),
                  route(
                    s(DOCUMENTS_TAB_KEY),
                    Documents,
                    STAFF_DOCTOR_DOCUMENTS_VIEW_NAME,
                    {
                      meta: {
                        isHideCabinetHead: true,
                        title: () => $t('Doctor documents'),
                      },
                    }
                  ),
                  route(
                    s(SPECIALIZATION_TAB_KEY),
                    Specializations,
                    STAFF_DOCTOR_SPECIALIZATION_VIEW_NAME,
                    {
                      meta: {
                        isHideCabinetHead: true,
                        title: () => $t('Doctor specialization'),
                      },
                    }
                  ),
                  route(
                    s(PLACE_OF_EMPLOYMENT_TAB_KEY),
                    PlaceOfEmployment,
                    STAFF_DOCTOR_PLACE_OF_EMPLOYMENT_VIEW_NAME,
                    {
                      meta: {
                        isHideCabinetHead: true,
                        title: () => $t('Doctor place of employment'),
                      },
                    }
                  ),
                ],
                {
                  name: STAFF_DOCTOR_VIEW_NAME,
                  redirect: { name: STAFF_DOCTOR_GENERAL_VIEW_NAME },
                  meta: {},
                  component: View,
                  props: {
                    resource: adminApi.doctors.detail,
                    resourceKey: 'id',
                    routeKey: 'id',
                  },
                }
              ),
            ],
            Receive,
            '',
            'id',
            'id',
            {
              isHideCabinetHead: true,
            }
          ) as any),
        },
      ],
      {
        ...options,
      }
    ),
    //   ],
    //   options
    // ),
  ]
}
